<script lang="ts">
    import { _ } from "svelte-i18n"
    import { getTopicById, topics } from "../../../../store"
    import MedialibImage from "../../../widgets/MedialibImage.svelte"
    import MoreButton from "../../../widgets/MoreButton.svelte"
    import SectionTitleWrapper from "../../../widgets/SectionTitleWrapper.svelte"
    import SliderWrapper from "../SliderWrapper.svelte"
    import { onMount } from "svelte"
    import { animateOnVisible } from "../../../../configs/config"

    let {
        cards,
        articlesPreview,
        page_reference,
    }: { cards: ArticleEntryContent[]; articlesPreview: ArticlePreview; page_reference: string } = $props()
    let topicsSet = $derived(Object.values($topics).length > 0)
    onMount(() => {
        animateOnVisible("li.h-slider-card", {
            opacity: [0, 1],
            delay: (_, i) => i * 80,
            duration: 300,
            easing: "easeInOutQuad",
        })
    })
</script>

<section class="wrapper horizontal-article-slider">
    <SectionTitleWrapper
        styles="gap: 0px;"
        type="reference"
        title={articlesPreview.sticky_header_title}
        referenceTitle={$_("general.all-positions")}
        page="/{page_reference}"
    >
        {#snippet content()}
            <div style="height: 80px;"></div>
            <SliderWrapper rightDefaultMargin={true}>
                {#snippet slider()}
                    <ul class="inner-slider-wrapper">
                        {#each cards as card}
                            <li class="{card.person_reference ? 'type-opinion' : ''} h-slider-card">
                                <MedialibImage id={card.background_image} alt={card.title} />
                                <MedialibImage
                                    id={card.hover_preview_image || card.background_image}
                                    alt={card.title}
                                />
                                <div class="content">
                                    <div class="upper">
                                        {#if card.tag}
                                            <strong>{card.tag}</strong>
                                        {/if}
                                        {#if getTopicById(card.topics_reference)?.length && topicsSet}
                                            <span class="topic">
                                                {getTopicById(card.topics_reference)[0].title}
                                            </span>
                                        {/if}
                                    </div>
                                    <h3>
                                        {card.title}
                                    </h3>
                                    <div class="small-dividor"></div>
                                    {#if card.person_reference}
                                        <small style="font-size: 0.7rem; margin-top: -0.3rem;">
                                            {card.person_reference}
                                        </small>
                                    {/if}
                                    <MoreButton
                                        text={$_("general.read-more")}
                                        path="/{card.id}"
                                        type="dark"
                                        size="big"
                                    />
                                </div>
                            </li>
                        {/each}
                    </ul>
                {/snippet}
            </SliderWrapper>
        {/snippet}
    </SectionTitleWrapper>
</section>

<style lang="less" global>
    @import "../../../../css/variables.less";
    .wrapper.horizontal-article-slider {
        width: 100%;
        max-height: 900px;
        overflow: hidden;
        header {
            display: flex;
            justify-content: center;
            .inner-wrapper {
                max-width: var(--extended-max-width);
                width: 100%;
                margin: 0px var(--default-padding);
                display: flex;
                align-items: center;
                gap: 0.6rem;
                h3 {
                    color: var(--dark-100, #242220);
                    font-size: 20px;
                    font-weight: 700;
                    line-height: normal;
                    text-transform: uppercase;
                }
                .page-dividor {
                    flex: 1;
                    height: 1px;
                    background: var(--dark-20);
                }
            }
        }
        .inner-slider-wrapper {
            display: flex;
            padding-right: var(--default-padding);
            gap: 2.4rem;
            cursor: grab;
            li {
                min-width: 288px;
                &.type-opinion {
                    min-width: 512px;
                }
                @media @max-mobile {
                    min-width: calc(100vw - 2 * var(--default-padding)) !important;
                    width: calc(100vw - 2 * var(--default-padding));
                }
                &:hover {
                    transform: translateY(-20px);
                }
                position: relative;
                img {
                    width: 100%;
                    border-radius: 4px;
                    height: 292px;
                    object-fit: cover;
                }
                picture:last-of-type {
                    img {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        opacity: 0;
                        transition: opacity 0.3s ease-in-out;
                    }
                }

                &:hover {
                    picture:last-of-type {
                        img {
                            opacity: 1;
                        }
                    }
                }
                .content {
                    display: flex;
                    flex-direction: column;
                    gap: 0.6rem;
                    .upper {
                        strong {
                            color: var(--dark-100);
                            font-weight: 700;
                        }
                        span {
                            font-size: 0.7rem;
                            font-style: normal;
                            font-weight: 400;
                            line-height: 1.2rem;
                            text-transform: uppercase;
                        }
                    }
                }
            }
        }
    }
    .small-dividor {
        width: 48px;
        height: 1px;
        background: var(--dark-20);
    }
</style>
